function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070"
    },
    d: "m11.3 3.8-.9-.9L6 7.3 1.6 2.9l-.9.9 4.4 4.4.9.9.9-.9 4.4-4.4z"
  }));
};
export default SvgDropdown;